import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-fashion-offers",
  templateUrl: "./fashion-offers.component.html",
  styleUrls: ["./fashion-offers.component.scss"],
})
export class FashionOffersComponent implements OnInit {
  @Input() ProductsOffers = [];
  constructor(private _Router: Router) {}

  ngOnInit() {
  }
  selectedProducts(offerData) {
    // //console.log(offerData);
    let queryParams = { prod_ids: offerData.offer_id };
    this._Router.navigate(
      ["/shop/Category/selected_products/" + offerData.title],
      {
        queryParams,
      }
    );
  }

  formShape(offer_data: any) {
    // //console.log("fromRounting", offer_data);

    const groupedOffers: { [key: string]: string[] } =
      offer_data.offer_id.reduce((acc: { [key: string]: string[] }, offer) => {
        if (!acc[offer.key]) {
          acc[offer.key] = [];
        }
        acc[offer.key].push(offer.value);
        return acc;
      }, {});

    const queryParams: { [key: string]: string } = {};
    for (const [key, values] of Object.entries(groupedOffers)) {
      queryParams[`form_${key}`] = values.join(",");
    }

    // //console.log(queryParams);
    this._Router.navigate(["/shop/Category/form_shapes/" + offer_data.title], {
      queryParams,
    });
  }

  removeBrackets(str: string): string {
    return str?.replace(/[\(/%]/g, "");
  }
  handleImageError(e) {
    e.src = "assets/images/product/imgerror.svg";
  }

  isOfferValid(endDate: string): boolean {
    if (!endDate) return false;
    const now = new Date();
    const offerEndDate = new Date(endDate);
    return offerEndDate > now;
  }
}
